export default {
  path: '/receivablesAndPayables',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'receivables',
      name: 'receivables',
      component: () => import('@/pages/receivablesAndPayables/receivables/index.vue'),
      meta: {
        keepAlive: true,
        title: '应收结算费用清单',
      },
    },
    {
      path: 'receivablesList',
      name: 'receivablesList',
      component: () =>
        import('@/pages/receivablesAndPayables/receivables/receivableStatementList/index.vue'),
      meta: {
        keepAlive: true,
        title: '应收结算列表',
      },
    },
    {
      path: 'tradeReceivablesDetail',
      name: 'tradeReceivablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/Trade/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '贸易应收结算单',
      },
    },
    {
      path: 'payables',
      name: 'payables',
      component: () => import('@/pages/receivablesAndPayables/payables/index.vue'),
      meta: {
        keepAlive: true,
        title: '应付结算费用清单',
      },
    },
    {
      path: 'payableList',
      name: 'payableList',
      component: () => import('@/pages/receivablesAndPayables/payables/list.vue'),
      meta: {
        keepAlive: true,
        title: '应付结算单列表',
      },
    },
    {
      path: 'tradePayablesDetail',
      name: 'tradePayablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/trade/settleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '贸易应付结算单',
      },
    },
    {
      path: 'multimodalTransportExpenseListYSDetail',
      name: 'multimodalTransportExpenseListYSDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/MultimodalTransport/ExpenseListDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '多式联运应收费用详情',
      },
    },
    {
      path: 'multimodalTransportReceivablesDetail',
      name: 'multimodalTransportReceivablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/MultimodalTransport/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '多式联运应收结算单',
      },
    },
    {
      path: 'multimodalTransportExpenseListYFDetail',
      name: 'multimodalTransportExpenseListYFDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/multimodalTransport/ExpenseListDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '多式联运应付费用详情',
      },
    },
    {
      path: 'multimodalTransportPayablesDetail',
      name: 'multimodalTransportPayablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/multimodalTransport/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '多式联运应付结算单',
      },
    },
    {
      path: 'parkWarehouseReceivablesDetail',
      name: 'parkWarehouseReceivablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/ParkWarehouse/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '园区仓储应收结算单',
      },
    },
    {
      path: 'leaseContractDetail',
      name: 'leaseContractDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/LeaseContract/LeaseContractDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '三方租赁应付结算单',
      },
    },
    {
      path: 'superviseContractDetail',
      name: 'superviseContractDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/SuperviseContract/SuperviseContractDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '监管单应收结算单',
      },
    },
    {
      path: 'parkPropertyReceivablesCreate',
      name: 'parkPropertyReceivablesCreate',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/ParkProperty/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '创建应收结算单',
      },
    },
    {
      path: 'parkPropertyReceivablesDetail',
      name: 'parkPropertyReceivablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/ParkProperty/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '应收结算单详情',
      },
    },
    {
      path: 'parkPropertyPayablesCreate',
      name: 'parkPropertyPayablesCreate',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/parkProperty/settleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '应付结算单创建',
      },
    },
    {
      path: 'parkPropertyPayablesDetail',
      name: 'parkPropertyPayablesDetail',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/parkProperty/settleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '应付结算单详情',
      },
    },
    {
      path: 'chengkuangPayablesCreate',
      name: 'chengkuangPayablesCreate',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/components/chengkuangTrad/settleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '应付结算单创建',
      },
    },
    {
      path: 'payableListCK',
      name: 'payableListCK',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/payables/payableStatementList/chengkuangPayableList/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '应付结算单列表',
      },
    },
    {
      path: 'tradeReceivablesDetailCK',
      name: 'tradeReceivablesDetailCK',
      component: () =>
        import(
          '@/pages/receivablesAndPayables/receivables/components/ChengKuangTrad/SettleAccountsDetail/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '城矿应收结算单',
      },
    },
  ],
};
